import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UsersService } from '../../services/users/Users';
import { AuditEvents } from '../../interfaces/Netbird';

const service = new UsersService();

interface NetbirdEventsState {
  events: AuditEvents[];
  status: 'idle' | 'loading' | 'failed';
  error: string | null;
}

const initialState: NetbirdEventsState = {
  events: [],
  status: 'idle',
  error: null,
};

export const fetchVpnEvents = createAsyncThunk(
  'netbirdEvents/fetchVpnEvents',
  async (
    { companyId, eventType }: { companyId: number; eventType: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await service.getVpnEvents(companyId, eventType);
      return response.peers || [];
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const netbirdEventsSlice = createSlice({
  name: 'netbirdEvents',
  initialState,
  reducers: {
    setVpnEvents: (state, action: PayloadAction<AuditEvents[]>) => {
      state.events = action.payload;
    },
    addVpnEvent: (state, action: PayloadAction<AuditEvents>) => {
      state.events.unshift(action.payload);
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVpnEvents.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(
        fetchVpnEvents.fulfilled,
        (state, action: PayloadAction<AuditEvents[]>) => {
          state.status = 'idle';
          state.events = action.payload;
        }
      )
      .addCase(fetchVpnEvents.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const { setVpnEvents, addVpnEvent, clearError } =
  netbirdEventsSlice.actions;
export default netbirdEventsSlice.reducer;
